import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { ISerpPresenceFilter } from '../../model/types/SERPPresenceFilter.interface'
import { selectSerpPresenceFilters } from '../../model/serpPresenceSlice'
import React, { useEffect, useState } from 'react'
import { Square } from '../../../../shared/components/utility/square/Square'
import { ColumnsType } from 'antd/lib/table'
import { BpTable } from '../../../../shared/components/cards/table/BpTable'
import { TTableResponse } from '../../../../shared/types/TableResponse.type'
import { IBpPaginationProps } from '../../../../shared/components/cards/pagination/BpPagination'
import { SorterResult } from 'antd/lib/table/interface'
import { useSorter } from '../../../../shared/lib/hooks/UseSorter'
import { useTranslation } from 'react-i18next'
import {
  BrandPresenceItems,
  BrandPresencePagesArg,
  BrandPresencePagesItems,
  GetResearchBrandPresencePagesApiArg,
  useGetResearchBrandPresencePagesQuery,
} from '../../../../app/api'
import { PageCell } from '../../ui/cells/PageCell'
import { SerpCell } from '../../../../shared/ui/cells/SerpCell'
import { LandingPageCell } from '../../../../shared/ui/cells/LandingPageCell'
import { AvgPositionCell } from '../../../../shared/ui/cells/AvgPositionCell'
import styles from './SerpPresenceTableExpandRow.module.scss'

interface SerpPresenceExpandRowProps {
  record: BrandPresenceItems
}

export const SerpPresenceTableExpandRow = ({ record }: SerpPresenceExpandRowProps) => {
  const { t } = useTranslation()
  const detailedInfoFilter = useAppSelector<ISerpPresenceFilter>(selectSerpPresenceFilters)
  const {
    project,
    country,
    engine_id,
    dateRange: date,
    no_serp_presence,
    is_seo,
    page_url,
  } = detailedInfoFilter

  const [queryParams, setQueryParams] = useState<Partial<BrandPresencePagesArg>>()
  const { data, isLoading, isFetching } = useGetResearchBrandPresencePagesQuery(
    queryParams as GetResearchBrandPresencePagesApiArg,
    { skip: !project || queryParams == undefined },
  )

  useEffect(() => {
    if (!project) return

    setQueryParams({
      page: 1,
      'per-page': 10,
      projectId: +project,
      countryId: country ? +country : undefined,
      engineId: +engine_id,
      date,
      keyword: record.keyword,
      keywordId: record.keyword_id,
      noSerpPresence: no_serp_presence,
      isSeo: is_seo,
      landingId: page_url || undefined,
    })
  }, [detailedInfoFilter])

  const columns: ColumnsType<BrandPresencePagesItems> = [
    {
      title: t('table.columns.page'),
      dataIndex: 'page',
      key: 'page',
      render: (_: string, record) => <PageCell {...record} />,
    },
    {
      title: t('table.columns.avgPosition'),
      dataIndex: 'position',
      key: 'position',
      render: (_: string, record) => <AvgPositionCell {...record} />,
      sorter: true,
    },
    {
      title: t('table.columns.landingPage'),
      dataIndex: 'link_screen_url',
      key: 'link_screen_url',
      render: (_: string, record) => <LandingPageCell {...record} />,
    },
    {
      title: t('table.columns.SERP'),
      dataIndex: 'search_screen_url',
      key: 'search_screen_url',
      render: (_: string, record) => <SerpCell {...record} />,
    },
    {
      title: t('table.columns.lastFound'),
      dataIndex: 'last_found',
      key: 'last_found',
      width: 150,
      sorter: true,
    },
  ]

  const handleTableChange = (
    { current, pageSize }: IBpPaginationProps,
    sorter?: SorterResult<BrandPresencePagesItems> | SorterResult<BrandPresencePagesItems>[],
  ) => {
    if (queryParams) {
      setQueryParams({
        ...queryParams,
        page: current,
        'per-page': pageSize,
        sort: useSorter(sorter),
      })
    }
  }

  return (
    <Square className={styles.square}>
      <BpTable
        className='transparent-header'
        columns={columns}
        data={data as TTableResponse<BrandPresencePagesItems>}
        dataSource={data?.data?.items}
        hidePagination={!data?.data || data.data.total <= 10}
        loading={isLoading || isFetching}
        scroll={{ x: 0 }}
        onChange={(pagination, filters, sorter) => handleTableChange(pagination, sorter)}
      ></BpTable>
    </Square>
  )
}
